module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-SemiboldItalic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-SemiboldItalic-webfont.svg
// module id = 368
// module chunks = 0